import React, {useRef} from 'react';

export default function FileUploader({text, accept, className, handleFile}) {
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = event => {
    const fileUploaded = event.target.files[0];
    handleFile(fileUploaded);
  };

  return (
    <>
      <button
        className={className ? className : 'btn btn-primary'}
        onClick={handleClick}
      >
        {text}
      </button>
      <input
        type="file"
        onChange={handleChange}
        ref={hiddenFileInput}
        accept={accept}
        style={{display: 'none'}}
      />
    </>
  );
}
